import {
  Carousel as JLDSCarousel,
  CarouselProps,
} from "@JohnLewisPartnership/jl-design-system/dist/components/carousel/Carousel";
import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "@~/types/types.ts";
import { getProductKey } from "../utils/getProductKey";

function validateHeadingSize(s: unknown): "small" | "large" | undefined {
  switch (s) {
    case "small":
      return "small";
    case "large":
      return "large";
    default:
      return undefined;
  }
}

function validateCarouselVariant(
  s: unknown,
): CarouselProps["variant"] | undefined {
  switch (s) {
    case "scroll-by-page":
      return "scroll-by-page";
    case "scroll-by-item":
      return "scroll-by-item";
    default:
      return "scroll-by-page";
  }
}

export const Carousel: ProductListLayout = ({
  config,
  products,
  heading,
  instanceId,
}) => {
  const headingSize = validateHeadingSize(
    config["product-list-layout"]?.props?.headingSize,
  );

  const carouselVariant = validateCarouselVariant(
    config["product-list-layout"]?.props?.carouselVariant,
  );

  return (
    <JLDSCarousel
      id="carousel"
      ariaLabel="carousel"
      heading={heading?.main}
      subheading={heading?.subHeading ?? undefined}
      headingSize={headingSize}
      variant={carouselVariant}
    >
      {products.map((product, ind) => (
        <ProductCard
          key={getProductKey(product)}
          product={product}
          config={config}
          index={ind}
          instanceId={instanceId}
        />
      ))}
    </JLDSCarousel>
  );
};
